// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.EyeHidden = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EyeHidden = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var EyeHidden = _exports.EyeHidden = function EyeHidden(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.331 15.195a.625.625 0 0 1 .809-.357c.622.24 1.248.37 1.86.37a.625.625 0 1 1 0 1.25c-.79 0-1.568-.167-2.311-.455a.625.625 0 0 1-.358-.808",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.699 9.84a.625.625 0 0 1 .252.847c-.826 1.528-2.003 2.958-3.367 4.012-1.36 1.052-2.948 1.76-4.584 1.76a.625.625 0 1 1 0-1.25c1.276 0 2.601-.557 3.82-1.499 1.214-.938 2.282-2.23 3.032-3.618a.625.625 0 0 1 .847-.252",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.493 6.959a.625.625 0 0 1 .88.07c.603.704 1.14 1.475 1.578 2.284v.001c.23.428.23.945 0 1.373a.625.625 0 1 1-1.1-.594.2.2 0 0 0 0-.185 12 12 0 0 0-1.428-2.068.625.625 0 0 1 .07-.881M16.277 3.725a.625.625 0 0 1 0 .883L4.61 16.275a.625.625 0 1 1-.884-.884L15.393 3.725a.625.625 0 0 1 .884 0",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.414 8.585a2 2 0 0 0-2.828 2.829.625.625 0 0 1-.884.884A3.25 3.25 0 0 1 12.298 7.7a.625.625 0 1 1-.884.884",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.416 5.3C6.776 4.25 8.364 3.542 10 3.542s3.225.707 4.586 1.76a.625.625 0 1 1-.765.989c-1.218-.942-2.544-1.5-3.821-1.5s-2.602.557-3.82 1.498c-1.214.94-2.282 2.23-3.032 3.619l-.55-.297.55.296a.2.2 0 0 0 0 .186c.75 1.387 1.817 2.678 3.03 3.617a.625.625 0 1 1-.764.988c-1.363-1.054-2.54-2.483-3.366-4.01v-.001a1.45 1.45 0 0 1 0-1.373c.827-1.53 2.004-2.96 3.368-4.014",
      clipRule: "evenodd"
    }));
  };
});
